import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Row, Col, Table, Button } from "react-bootstrap";
import {
  PORTAL_ADMIN,
  PROJECT_ADMIN,
  HR_ADMIN,
  FINANCE_APPROVER,
  FINANCE_REPORTER,
  MANAGER,
  PROJECT_SPONSOR,
  TEAM_LEADER,
  EMPLOYEE,
  fetchUsers,
} from "../../store/actions/users/usersActions";
import {
  createDailyTask,
  fetchTeamDailyTaskEntryDetailsById,
  resetDailyTasks,
} from "../../store/actions/timesheet/taskActions";
import PageTitle from "../../common/PageTitle";
import moment from "moment";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { getProjectsJSON } from "../../store/actions/projects/projectsActions";
import { Cache } from "aws-amplify";
import { fetchProjectMembers } from "../../store/actions/projects/projectMembersActions";

class TeamDailyTasks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCurrentDate: false,
    };
    this.members = {};
    this.empIds = {};
    this.costCenters = {};
    this.roleId = Cache.getItem("roleId") || 0;
    this.state = {
      startDate: "",
    };
    this.userId = Cache.getItem("userId");
  }
  componentDidMount() {
    this.selectedDate = new Date();

    this.props.fetchUsers({ supervisor_id: this.userId });
  }

  handleCreate = async () => {
    const id = await this.props.createDailyTask();
    this.props.history.push(`/dailytasks/view?id=${id}`);
  };

  displayProjectDropDown = () => {
    let isAdmin =
      this.roleId === PORTAL_ADMIN ||
      this.roleId === PROJECT_ADMIN ||
      this.roleId === HR_ADMIN ||
      this.roleId === FINANCE_APPROVER ||
      this.roleId === FINANCE_REPORTER
        ? true
        : false;

    let projectsJSON = this.props.getProjectsJSON(
      { includeGenAdmin: false, is_disabled: 0 },
      isAdmin
    );

    //generate project arrays
    this.projects = projectsJSON.map((project) => {
      return project.value;
    });

    // if ((this.roleId !== EMPLOYEE) && projectsJSON.length) {
    //   projectsJSON.unshift({
    //     key: 0,
    //     value: "all",
    //     label: '--SELECT ALL PROJECTS--'
    //   });
    // }

    const selectClass = "projectSelect";

    return (
      <Select
        // isMulti
        placeholder="Select Project"
        className={selectClass}
        classNamePrefix={selectClass}
        size="sm"
        onChange={(selectedOption) => {
          this.projectId = selectedOption.value;
          this.props.fetchProjectMembers(this.projectId);
          // if (this.projectId) {
          //   if (this.projectId === "all") {
          //     this.projectId = this.projects;
          //   }

          //   // this.props.fetchProjectMembers(this.projectId);
          // }
        }}
        options={projectsJSON}
      />
    );
  };

  displayMembersDropdown = () => {
    let members = [];
    const currentUser = this.props.users.currentUser;
    // if (currentUser) {
    //   members = [currentUser];
    // }
    const selectClass = "memberSelect";

    if (this.roleId === MANAGER || this.roleId === PROJECT_SPONSOR) {
      const projects = this.props.projects.projectMembers;
      if (projects && projects.length) {
        members = [
          ...members,
          ...projects
            .filter((data) => {
              if (typeof data.user !== "undefined") {
                const user = data.user;
                if (!user) {
                  return null;
                }

                if (user.id !== currentUser.id) {
                  return data;
                }
              }
              return false;
            })
            .map((project) => project.user),
        ];
      }
    } else if (
      this.roleId === TEAM_LEADER ||
      this.roleId === PORTAL_ADMIN ||
      this.roleId === HR_ADMIN ||
      this.roleId === FINANCE_APPROVER ||
      this.roleId === FINANCE_REPORTER ||
      this.roleId === PROJECT_ADMIN
    ) {
      const users = this.props.users;
      const projectMembers = this.props.projects.projectMembers;
      const hasProjectSelected = !!this.projectId;

      if (users && users.users) {
        if (this.roleId === TEAM_LEADER && hasProjectSelected && projectMembers && projectMembers.length) {
          const supervisedIds = users.users.map((u) => u.id);
          const projectMemberUsers = projectMembers.map((data) => data.user);
  
          // Keep only those who are in both lists
          members = projectMemberUsers.filter(
            (member) => member && supervisedIds.includes(member.id)
          );
        } else {
          members = [...members, ...users.users];
        }
      }
    } else if (this.roleId === EMPLOYEE) {
      this.projectMemberId = this.userId;
      this.members[this.userId] = this.getFullName(currentUser);
      if (
        currentUser.employee_id &&
        typeof currentUser.employee_id !== "undefined"
      ) {
        this.empIds[this.userId] = currentUser.employee_id
          .toString()
          .padStart(5, "0");
      }

      if (currentUser.user_cost_center) {
        this.costCenters[this.userId] = currentUser.user_cost_center;
      }

      return "";
    }

    let memberList = [
      // {
      //   key: 0,
      //   value: "all",
      //   label: "--SELECT ALL MEMBERS--",
      // },
    ];

    if (members && members.length) {
      this.memberIds = members.map((member) => {
        if (member) {
          return member.id;
        }
        return false;
      });

      members.forEach((member) => {
        if (Object.keys(member).length) {
          const fullName = this.getFullName(member);
          const costCenter = member.user_cost_center;
          memberList.push({
            key: member.id,
            value: member.id,
            label: fullName,
          });

          if (!(member.id in this.members)) {
            this.members[member.id] = fullName;
            if (
              member.employee_id &&
              typeof member.employee_id !== "undefined"
            ) {
              this.empIds[member.id] = member.employee_id
                .toString()
                .padStart(5, "0");
            }

            if (costCenter) {
              this.costCenters[member.id] = costCenter;
            }
          }
        }
      });
    }

    return (
      <Select
        className={selectClass}
        classNamePrefix={selectClass}
        placeholder={"Select Member"}
        size="sm"
        onChange={(selectedOption) => {
          this.projectMemberId = selectedOption.value;
        }}
        options={memberList}
      />
    );
  };

  displayStartDate = () => {
    return (
      <DatePicker
        placeholderText="* Select Date"
        maxDate={this.selectedDate}
        onChange={(date) => {
          this.setState({ startDate: date });

          // this.props.refreshReports();
        }}
        selected={this.state.startDate}
      />
    );
  };

  getFullName = (member) => {
    if (member && typeof member !== "undefined") {
      const firstName = member.first_name || "";
      const middleName = member.middle_name || "";
      const lastName = member.last_name || "";
      return lastName + ", " + firstName + " " + middleName;
    }
  };

  handleSubmit = () => {
    const user_id = Cache.getItem("userId");
    const selectedDate = moment(this.state.startDate).format("YYYY-MM-DD");
    this.props.fetchTeamDailyTaskEntryDetailsById(
      user_id,
      this.projectMemberId,
      this.projectId,
      selectedDate,
      this.roleId
    );
  };

  renderDailyTasks = () => {
    // const dailyTasks = this.props.dailyTasks.teamDailyTask;
    const dailyTasks = this.props.dailyTasks.teamDailyTask;
    let dailyTaskList = "";

    if (dailyTasks) {
      dailyTaskList = dailyTasks.length ? (
        dailyTasks.map((dailyTask, key) => {
          const status = JSON.parse(dailyTask.status);
          // if (dailyTask.date === this.state.currentDate) {
          //   this.state.isCurrentDate = true;
          // }
          return (
            <tr key={key}>
              <td className="align-center" colSpan={2}>
                <span>{dailyTask.date}</span>
              </td>
              <td className="align-center" colSpan={3}>
                {`${dailyTask.first_name} ${dailyTask.middle_name ?? ""} ${
                  dailyTask.last_name
                }`}
              </td>
              <td colSpan={5}>
                <tr className=" d-flex justify-content-center">
                  {status !== null ? (
                    <>
                      <strong style={{ color: "#ffc107" }}>
                        {`Pending: ${status.pending};`} &nbsp;
                      </strong>
                      <strong style={{ color: "#6c757d" }}>
                        {` On hold: ${status.on_hold};`} &nbsp;
                      </strong>
                      <strong style={{ color: "#17a2b8" }}>
                        {`On Going: ${status.on_going};`} &nbsp;
                      </strong>
                      <strong style={{ color: "#28a745" }}>
                        {`Completed: ${status.completed};`} &nbsp;
                      </strong>
                      <strong style={{ color: "#CC3333" }}>
                        {`Failed: ${
                          status.failed !== undefined ? status.failed : 0
                        };`}
                        &nbsp;
                      </strong>
                    </>
                  ) : (
                    <strong>Not Started</strong>
                  )}
                </tr>
              </td>
              <td className="align-center" colSpan={2}>
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.resetDailyTasks();
                    this.props.history.push(
                      `/dailytasks/view?id=${dailyTask.daily_task_id}&user_id=${dailyTask.user_id}`
                    );
                  }}
                >
                  View
                </Button>
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={4}>
            <i>No Results</i>
          </td>
        </tr>
      );
    } else {
      dailyTaskList = (
        <tr>
          <td colSpan={4}>
            <p className="text-danger">No Tasks found.</p>
          </td>
        </tr>
      );
    }

    return (
      <Table hover>
        <thead className="align-center">
          <tr>
            <th colSpan={2}>Date</th>
            <th colSpan={3}>Name</th>
            <th colSpan={5}>Status</th>
            <th colSpan={2}>Actions</th>
          </tr>
        </thead>
        <tbody className="h-auto">{dailyTaskList} </tbody>
      </Table>
    );
  };

  render() {
    const currentDate = moment().format("YYYY-MM-DD");
    const dailyTasks = this.props.dailyTasks.dailyTasks;

    if (dailyTasks) {
      dailyTasks.map((dailyTask, key) => {
        if (dailyTask.date === currentDate) {
          this.state.isCurrentDate = true;
        }
      });
    }
    // const addDailyTaskBtn = (
    //   <Button
    //     size="sm"
    //     disabled={this.state.isCurrentDate}
    //     onClick={() => {
    //       this.handleCreate();
    //       this.props.resetDailyTasks();
    //       // this.props.fetchDailyTasks();
    //       // this.setState({ isCurrentDate: true });
    //     }}
    //   >
    //     Add Daily Task
    //   </Button>
    // );
    return (
      <React.Fragment>
        <PageTitle pageName="Team Daily Tasks" />
        <Row className="mt-2">
          <Col>{this.displayProjectDropDown()}</Col>
          <Col>{this.displayMembersDropdown()}</Col>
          <Col className="col-auto">{this.displayStartDate()}</Col>

          <Col>
            <Button onClick={this.handleSubmit}>Search</Button>
          </Col>
        </Row>
        <Row>
          <Col>{this.renderDailyTasks()}</Col>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  dailyTasks: state.dailyTasks,
  projects: state.projects,
  users: state.users,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTeamDailyTaskEntryDetailsById: (...args) =>
      dispatch(fetchTeamDailyTaskEntryDetailsById(...args)),
    createDailyTask: () => dispatch(createDailyTask()),
    resetDailyTasks: () => dispatch(resetDailyTasks()),
    getProjectsJSON: () => dispatch(getProjectsJSON()),
    fetchProjectMembers: (...args) => dispatch(fetchProjectMembers(...args)),
    fetchUsers: (...args) => dispatch(fetchUsers(...args)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TeamDailyTasks)
);
